import "@rmlibrary/fetch";
import "@rmlibrary/scroll";
import RMModal from "@rmlibrary/modal";
import { RMTooltip } from "@rmlibrary/tooltip";

import $ from "jquery";
import { fetchRates, payoutPrepayLogic, getInterestRateDifferentialValues } from "./logic";
import {
    format,
    formatCurrency,
    formatDate,
    formatNumber,
    formatPercentage,
    getDateSuffix,
    getMonthDays,
    getMonthName,
    isValidDate,
    parseDate,
    parseNumber,
    today,
} from "@rmlibrary/formatting";
import { populateYears, populateDays, numericOnlyInputs, lang, validateNumberField, getMapping } from "./utilities";
import { printPDF } from "./pdf";

let disclaimerModal;
let _isOpen = false;

// fetchRates();

const errorMessages = {
    en: {
        planPrepay: `The maximum value allowed for mortgage prepayment is ${formatCurrency(1200000, { lang })}.`,
        planPrepayLTCurrBalance: "The prepayment amount must be less than the current balance",
        originalAmount: `The value allowed for mortgage amount is between ${formatCurrency(1, {
            lang,
        })} and ${formatCurrency(1200000, {
            lang,
        })}.`,
        currentBalance: `The maximum value allowed for current balance is ${formatCurrency(1200000, { lang })}.`,
        currentBalaneLTOriginalAmount: "The current balance must not be greater than the original mortgage",
        monthsTerm: "The remaining months cannot be greater than the term selected:",
        currentRate: `The value allowed for interest rate is between ${formatPercentage(0.1, {
            lang,
        })} and ${formatPercentage(10, { lang })}.`,
        fixedRateDiscount: `The maximum value allowed for fixed rate discount is ${formatPercentage(3.25, { lang })}.`,
        variableCapRate: `The maximum value allowed for cap rate is between ${formatPercentage(15, { lang })}.`,
        cashback: `The maximum value allowed for cash back is ${formatCurrency(100000, { lang })}.`,
    },
    fr: {
        planPrepay: `Valeur maximum permise pour un remboursement anticipé : ${formatCurrency(1200000, { lang })}.`,
        planPrepayLTCurrBalance: "Le montant de remboursement anticipè doit être infèrieur à l'équilibre actuel :",
        originalAmount: `La valeur autorisée pour le montant de l'hypothèque se situe entre ${formatCurrency(1, {
            lang,
        })} et ${formatCurrency(1200000, {
            lang,
        })}.`,
        currentBalance: `Valeur maximum permise pour un remboursement anticipé intégral : ${formatCurrency(1200000, {
            lang,
        })}.`,
        currentBalaneLTOriginalAmount: "L'équilibre actuel ne doit pas être supérieur à l'hypothèque initiale :",
        monthsTerm: "Les mois restants ne peuvent pas être supérieure à la durée choisie :",
        currentRate: `La valeur autorisée pour le taux d'intérêt est comprise entre ${formatPercentage(0.1, {
            lang,
        })} et ${formatPercentage(10, { lang })}.`,
        fixedRateDiscount: `Valeur maximum permise pour le taux réduit : ${formatPercentage(3.25, { lang })}.`,
        variableCapRate: `Valeur maximum permise pour le taux plafond : ${formatPercentage(15, { lang })}.`,
        cashback: `Valeur maximum permise pour la remise en espèces : ${formatCurrency(100000, { lang })}.`,
    },
};

function getUserInputs() {
    const isPrepay = $("#estimated-cost").val() === "prepay";
    const isFixed = $("#fixed-rate").is(":checked");
    const isOpen = _isOpen; //$("#term-open").val() === "open";
    const originalMortgage = parseNumber($("#OriginalAmount").val());
    const currentBalance = parseNumber($("#CurrentBalance").val());
    const rate = parseNumber(isFixed ? $("#fixed-rate-year").val() : $("#variable-rate-year").val());
    const monthsRemainingOnCurrentTerm = parseNumber($("#months-term").val());
    const currentRate = parseNumber($("#current-rate").val()) / 100;
    const prepaymentAmount = parseNumber($("#PlanPrepay").val());
    const cashback = parseNumber($("#received-cashback").val());
    const discountRate = parseNumber($("#fixed-rate-discount").val()) / 100;
    const capRate = parseNumber($("#variable-cap-rate").val()) / 100;

    const day = parseNumber($("#mortgage-day").val());
    const month = parseNumber($("#mortgage-month").val());
    const year = parseNumber($("#mortgage-year").val());

    const originalDate = new Date(`${month} ${day} ${year}`);

    const termPeriod = isFixed ? $("#fixed-rate-year option:eq("+$("#fixed-rate-year")[0].selectedIndex+")").text() : $("#variable-rate-year option:eq("+$("#variable-rate-year")[0].selectedIndex+")").text();

    return {
        originalMortgage,
        currentBalance,
        prepayment: prepaymentAmount,
        rate,
        isFixed,
        isOpen,
        isPrepayment: isPrepay,
        monthsRemainingOnCurrentTerm,
        currentRate,
        discountRate,
        capRate,
        cashback,
        originalDate,
        isPrepay,
        isPayout: !isPrepay,
        isVariable: !isFixed,
        isClosed: !isOpen,
        termPeriod,
    };
}

function getResults() {
    const userInput = getUserInputs();
    // console.log(userInput, "-----chk---", payoutPrepayLogic(userInput))
    return payoutPrepayLogic(userInput);

}

function attachEventHandlers() {
    $(".main-content input, .main-content select").on("change keydown", () => {
        $("#calculate-results").removeAttr("disabled");
        $(".result-section").addClass("hidden");
    });

    $(".main-content input").on("blur", (event) => {
        validateInputsOnBlur(event.target.id);
    });

    $("#fixed-rate-year, #variable-rate-year").on("change", (evt) => {
        _isOpen = (evt.target.value == 1 || evt.target.value == 2) ?  true : false;
        // (evt.target.value == 1 || evt.target.value == 2) ? toggleType(true) : toggleType(false);
        toggleType(_isOpen);
        validateInputsOnBlur("months-term");
    });

    $("#calculate-results").on("click", () => {
        if (validateInputs()) {
            const results = getResults();
            $("#charge-amount").text(formatCurrency(results.charge, { lang, decPlaces: 0 }));
            $("#cashback-repayment").text(formatCurrency(results.cashbackAmount, { lang, decPlaces: 0 }));
            $("#partial-prepayment").text(formatCurrency(results.partialPrepayment, { lang, decPlaces: 0 }));
            $(".dynamicResultText").empty();
            $(".dynamicResultText").text(results.dynamicResultText + ".");
            $(".result-section").removeClass("hidden");
            $("#calculate-results").prop("disabled", "true");
            // printPDF();
        }
    });

    $("#generate-print").on("click", () => {
        const inputs = getUserInputs();
        const results = getResults();
        const interestRateDifferentialValues = getInterestRateDifferentialValues({ ...inputs });
        printPDF({ ...inputs, ...results, ...interestRateDifferentialValues });
    });

    $("#estimated-cost").on("change", function () {
        if ($(this).val() === "payout") {
            $(".prepay-amount").addClass("disabled");
            $("#PlanPrepay").prop("disabled", "true");

            $("span.isPrepay").hide();
            $("span.isPayout").show();
        } else {
            $(".prepay-amount").removeClass("disabled");
            $("#PlanPrepay").removeAttr("disabled");

            $("span.isPrepay").show();
            $("span.isPayout").hide();
        }
    });

    // $("#term-open").on("change", function () {
    function toggleType (isOpen){
        if (isOpen) {
            //if ($(this).val() === "open") {
            $(".current-rate").addClass("disabled");
            $(".variable-cap-rate").addClass("disabled");
            $(".fixed-rate-discount").addClass("disabled");

            $("#current-rate").prop("disabled", "true");
            $("#variable-cap-rate").prop("disabled", "true");
            $("#fixed-rate-discount").prop("disabled", "true");
        } else {
            $(".current-rate").removeClass("disabled");
            $("#current-rate").removeAttr("disabled");

            if ($("#fixed-rate").is(":checked")) {
                $(".variable-cap-rate").addClass("disabled");
                $("#variable-cap-rate").prop("disabled", "true");

                $(".fixed-rate-discount").removeClass("disabled");
                $("#fixed-rate-discount").removeAttr("disabled");
            } else {
                $(".variable-cap-rate").removeClass("disabled");
                $("#variable-cap-rate").removeAttr("disabled");

                $(".fixed-rate-discount").addClass("disabled");
                $("#fixed-rate-discount").prop("disabled", "true");
            }
        }
    }
    // });

    $("#mortgage-month, #mortgage-year").on("change", function () {
        populateDays();
    });

    $("[name='rate-options']").on("change", function () {
        if ($("#fixed-rate").is(":checked")) {
            $(".variable-cap-rate").addClass("disabled");
            $("#variable-cap-rate").prop("disabled", "true");

            $(".fixed-rate-discount").removeClass("disabled");
            $("#fixed-rate-discount").removeAttr("disabled");
        } else {
            $(".variable-cap-rate").removeClass("disabled");
            $("#variable-cap-rate").removeAttr("disabled");

            $(".fixed-rate-discount").addClass("disabled");
            $("#fixed-rate-discount").prop("disabled", "true");
        }
    });

    $("button.clear").on("click", () => {
        disclaimerModal.open();
        $("#disclaimer-modal").removeClass("hidden");
    });

    $(".close_btn").on("click", () => {
        disclaimerModal.close();
        $("#disclaimer-modal").addClass("hidden");
    });
}

function validateInputs() {
    const isPrepay = $("#estimated-cost").val() === "prepay";
    const isFixed = $("#fixed-rate").is(":checked");
    let validity = true;
    const errorMessageText = errorMessages[lang];

    if (isPrepay) {
        validity =
            validity &
            validateNumberField(
                "#PlanPrepay",
                errorMessageText.planPrepay,
                [
                    {
                        input: "#CurrentBalance",
                        rule: "<",
                        message: `${errorMessageText.planPrepayLTCurrBalance} ${formatCurrency(
                            parseNumber($("#CurrentBalance").val()),
                            { lang },
                        )}.`,
                    },
                ],
                validity,
            );
    }

    validity = validity & validateNumberField("#OriginalAmount", errorMessageText.originalAmount, [], validity);

    validity =
        validity &
        validateNumberField(
            "#CurrentBalance",
            errorMessageText.currentBalance,
            [
                {
                    input: "#OriginalAmount",
                    rule: "<=",
                    message: `${errorMessageText.currentBalaneLTOriginalAmount} ${formatCurrency(
                        parseNumber($("#OriginalAmount").val()),
                        { lang },
                    )}.`,
                },
            ],
            validity,
        );

    validity =
        validity &
        validateNumberField(
            "#months-term",
            "",
            [
                {
                    input: isFixed ? "#fixed-rate-year" : "#variable-rate-year",
                    rule: "<=",
                    message: `${errorMessageText.monthsTerm} ${
                        getMapping(parseNumber($(isFixed ? "#fixed-rate-year" : "#variable-rate-year").val()))
                    } ${lang === "en" ? "months" : "mois"}.`,
                    isMonths: true,
                    mapping: true
                },
            ],
            validity,
            true,
        );

    validity = validity & validateNumberField("#current-rate", errorMessageText.currentRate, [], validity, true);

    if (isFixed) {
        validity =
            validity &
            validateNumberField("#fixed-rate-discount", errorMessageText.fixedRateDiscount, [], validity, true);
    } else {
        validity =
            validity & validateNumberField("#variable-cap-rate", errorMessageText.variableCapRate, [], validity, true);
    }

    validity = validity & validateNumberField("#received-cashback", errorMessageText.cashback, [], validity, true);

    return validity;
}

function validateInputsOnBlur(id) {
    const isPrepay = $("#estimated-cost").val() === "prepay";
    const isFixed = $("#fixed-rate").is(":checked");
    let validity = true;
    const errorMessageText = errorMessages[lang];

    if (isPrepay) {
        if (id === "PlanPrepay") {
            validity = validateNumberField(
                "#PlanPrepay",
                errorMessageText.planPrepay,
                [
                    {
                        input: "#CurrentBalance",
                        rule: "<",
                        message: `${errorMessageText.planPrepayLTCurrBalance} ${formatCurrency(
                            parseNumber($("#CurrentBalance").val()),
                            { lang },
                        )}.`,
                    },
                ],
                false,
            );
        }
    }

    if (id === "OriginalAmount") {
        validity = validity & validateNumberField("#OriginalAmount", errorMessageText.originalAmount, [], false);

        validity =
            validity &
            validateNumberField(
                "#CurrentBalance",
                errorMessageText.currentBalance,
                [
                    {
                        input: "#OriginalAmount",
                        rule: "<=",
                        message: `${errorMessageText.currentBalaneLTOriginalAmount} ${formatCurrency(
                            parseNumber($("#OriginalAmount").val()),
                            { lang },
                        )}.`,
                    },
                ],
                false,
            );
    }

    if (id === "CurrentBalance") {
        validity =
            validity &
            validateNumberField(
                "#CurrentBalance",
                errorMessageText.currentBalance,
                [
                    {
                        input: "#OriginalAmount",
                        rule: "<=",
                        message: `${errorMessageText.currentBalaneLTOriginalAmount} ${formatCurrency(
                            parseNumber($("#OriginalAmount").val()),
                            { lang },
                        )}.`,
                    },
                ],
                false,
            );

        validity =
            validity &
            validateNumberField(
                "#PlanPrepay",
                errorMessageText.planPrepay,
                [
                    {
                        input: "#CurrentBalance",
                        rule: "<",
                        message: `${errorMessageText.planPrepayLTCurrBalance} ${formatCurrency(
                            parseNumber($("#CurrentBalance").val()),
                            { lang },
                        )}.`,
                    },
                ],
                false,
            );
    }

    if (id === "months-term") {
        validity = validateNumberField(
            "#months-term",
            "",
            [
                {
                    input: isFixed ? "#fixed-rate-year" : "#variable-rate-year",
                    rule: "<=",
                    message: `${errorMessageText.monthsTerm} ${
                        getMapping(parseNumber($(isFixed ? "#fixed-rate-year" : "#variable-rate-year").val()))
                    } ${lang === "en" ? "months" : "mois"}.`,
                    isMonths: true,
                    mapping: true,
                },
            ],
            false,
        );
    }

    if (id === "current-rate") {
        validity = validateNumberField("#current-rate", errorMessageText.currentRate, [], false);
    }

    if (isFixed) {
        if (id === "fixed-rate-discount") {
            validity = validateNumberField("#fixed-rate-discount", errorMessageText.fixedRateDiscount, [], false);
        }
    } else {
        if (id === "variable-cap-rate") {
            validity = validateNumberField("#variable-cap-rate", errorMessageText.variableCapRate, [], false);
        }
    }

    if (id === "received-cashback") {
        validity = validity & validateNumberField("#received-cashback", errorMessageText.cashback, [], false);
    }

    return validity;
}

function setupTooltipsAndDisclaimerModal() {
    new RMTooltip($("[rm-tooltip-id='original-amount-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='fixed-variable-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='current-balance-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='current-term-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='current-rate-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='fixed-rate-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='variable-rate-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='cashback-tooltip']")[0]);
    new RMTooltip($("[rm-tooltip-id='first-take-out-tooltip']")[0]);

    const disclaimerEl = $("#disclaimer-modal")[0];
    disclaimerModal = RMModal.get(disclaimerEl, {
        closeOnBackdropClick: false,
        closeOnEscape: false,
        preventBackgroundScroll: true
    });
}

$(window).on("load", function () {
    populateYears();
    populateDays();
    numericOnlyInputs($(".main-content"), true);
    setupTooltipsAndDisclaimerModal();
    attachEventHandlers();
});
